import cn from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Link from '../../components/common/util/input/Link'
import Page from '../../components/page/Page'
import config from '../../config.json'
import { useSharedState } from '../../components/waxplorer/Waxplorer'
import { Card, CardBody } from '@nextui-org/react'

const BulkOverviewPage = (props) => {
    const { t } = useTranslation('common')

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const Item = ({ title, description, searchType }) => {
        return (
            <div className={cn('p-3')}>
                <Card className="border-2 dark:border-zinc-800 dark:bg-zinc-900">
                    <CardBody>
                        <Link
                            href={`/bulk?search_type=${searchType}${
                                searchType !== 'bulk_buy'
                                    ? `&owner=${userName}`
                                    : ''
                            }`}
                        >
                            <div
                                className={cn(
                                    'w-full px-5 py-5 dark:text-white text-black hover:text-primary h-32',
                                )}
                            >
                                <div
                                    className={cn(
                                        'mb-2 mt-0 text-3xl text-left',
                                    )}
                                >
                                    <b>{title}</b>
                                </div>
                                <div
                                    className={cn(
                                        'm-auto text-left text-md break-words dark:text-zinc-300 text-zinc-700',
                                    )}
                                >
                                    <b>{description}</b>
                                </div>
                            </div>
                        </Link>
                    </CardBody>
                </Card>
            </div>
        )
    }

    const flexClass = cn('w-full grid md:grid-cols-2 xl:grid-cols-3 pb-10 px-5')
    const dividerClass = cn('text-2xl pb-1 text-left px-10')

    return (
        <Page
            id={'BulkOverviewPage'}
            title={config.titles.bulkoverview}
            description={config.descriptions.bulk}
            {...props}
        >
            <div className={dividerClass}>
                {t('bulk_overview.buy_sell_tools')}
            </div>
            <div className={flexClass}>
                <Item
                    title={t('bulk_overview.sell_assets')}
                    description={t('bulk_overview.sell_assets_descr')}
                    searchType={'bulk_sell'}
                />
                <Item
                    title={t('bulk_overview.edit_listings')}
                    description={t('bulk_overview.edit_listings_descr')}
                    searchType={'bulk_edit'}
                />
                <Item
                    title={t('bulk_overview.auction_assets')}
                    description={t('bulk_overview.auction_assets_descr')}
                    searchType={'bulk_auction'}
                />
                <Item
                    title={t('bulk_overview.sell_duplicates')}
                    description={t('bulk_overview.sell_duplicates_descr')}
                    searchType={'bulk_sell_duplicates'}
                />
                <Item
                    title={t('bulk_overview.cancel_sales')}
                    description={t('bulk_overview.cancel_sales_descr')}
                    searchType={'bulk_cancel'}
                />
                <Item
                    title={t('bulk_overview.buy_assets')}
                    description={t('bulk_overview.buy_assets_descr')}
                    searchType={'bulk_buy'}
                />
            </div>
            <div className={dividerClass}>Transfer Tools</div>
            <div className={flexClass}>
                <Item
                    title={t('bulk_overview.transfer_assets')}
                    description={t('bulk_overview.transfer_assets_descr')}
                    searchType={'bulk_transfer'}
                />
                <Item
                    title={t('bulk_overview.transfer_duplicates')}
                    description={t('bulk_overview.transfer_duplicates_descr')}
                    searchType={'bulk_transfer_duplicates'}
                />
                <Item
                    title={t('bulk_overview.transfer_lowest_mints')}
                    description={t('bulk_overview.transfer_lowest_mints_descr')}
                    searchType={'bulk_transfer_lowest_mints'}
                />
                <Item
                    title={t('bulk_overview.distribute_assets')}
                    description={t('bulk_overview.distribute_assets_descr')}
                    searchType={'bulk_distribute'}
                />
                <Item
                    title={t('bulk_overview.burn_assets')}
                    description={t('bulk_overview.burn_assets_descr')}
                    searchType={'bulk_burn'}
                />
            </div>
            <div className={dividerClass}>Staking Tools</div>
            <div className={flexClass}>
                <Item
                    title={t('bulk_overview.unstake_assets')}
                    description={t('bulk_overview.unstake_assets_descr')}
                    searchType={'bulk_unstake'}
                />
            </div>
            <div className={dividerClass}>Bundle Tools</div>
            <div className={flexClass}>
                <Item
                    title={t('bulk_overview.bundle_assets')}
                    description={t('bulk_overview.bundle_assets_descr')}
                    searchType={'bulk_bundle'}
                />
            </div>
        </Page>
    )
}

export default BulkOverviewPage
